import {action, observable} from 'mobx';
import http from '../../http'

class FeedbackStore {
    @observable loading = true;
    @observable dataId = null;
    @observable ratingSrc = null;
    @observable rating = null;
    @observable room = null;
    @observable studio = null;
    @observable alertMessageType = 'success';
    @observable alertMessage = '';
    @observable comment = '';
    @observable firstLoad = true;
    @observable errorLoaded = false;
    @observable openAlert = false;
    @observable showComment = false;


    load = async () => {
        const regRes = window.location.pathname.match(/\/feedback\/(.*)/);
        if (regRes.length > 1) {
            this.dataId = regRes[1];
        }
        if (this.firstLoad) {
            Promise.resolve(() => true)
                .then(() => this.firstLoad = false)
                .then(this.getFeedback)
        }
    };

    ratingChanged = (event) => {
        this.ratingSrc = event.target.value
    };
    commentChanged = (event) => {
        this.comment = event.target.value
    };

    handleCloseAlert = () => {
        this.openAlert = false
    }

    @action
    getFeedback = () => {
        http.get(`/rates/room?id=${this.dataId}`)
            .then(({data}) => {
                this.rating = data.rating
                this.comment = data.comment
                this.room = data.room
                this.studio = data.studio
            })
            .then(() => this.loading = false)
            .catch(() => {
                this.alertMessage = 'Что-то пошло не так :('
                this.alertMessageType = 'error'
                this.openAlert = true
            })
    };
    @action
    saveFeedback = () => {
        if (!this.ratingSrc) {
            this.alertMessage = 'Нужно указать оценку'
            this.alertMessageType = 'warning'
            this.openAlert = true
        } else if (this.comment.length < 3) {
            this.alertMessage = 'Нужно указать комментарий к отзыву'
            this.alertMessageType = 'warning'
            this.openAlert = true
        } else {
            Promise.resolve(() => true)
                .then(() => this.loading = true)
                .then(() => http.post(`/rates/room?id=${this.dataId}`,
                    {
                        rating: this.ratingSrc,
                        comment: this.comment,
                    })
                    .then(({data}) => {
                        this.rating = data.rating
                        this.comment = data.comment
                        this.room = data.room
                        this.studio = data.studio
                        this.alertMessageType = 'success'
                        this.alertMessage = 'Спасибо за отзыв!'
                        this.openAlert = true
                        this.showComment = true
                    })
                    .then(() => this.loading = false)
                    .catch(() => {
                            this.loading = false
                            this.errorLoaded = true
                        }
                    ))

        }
    };


}

export {FeedbackStore};
